import { Search, Users, ArrowLeftRight, FlaskConical, Ship, Briefcase } from "lucide-react";
import { useLang } from "../i18n";
import { Chapter, Reveal } from "./Reveal";

const ICONS = [Search, Users, ArrowLeftRight, FlaskConical, Ship, Briefcase];

export function Services() {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 overflow-hidden">
      <div aria-hidden="true" className="absolute inset-0 overflow-hidden">
        <img src="/assets/bg-services.webp" alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-[#07111F]/78" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#07111F] via-transparent to-[#07111F]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Chapter kicker={t.services.kicker} title={t.services.title} testId="services" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div
                  data-testid={`service-card-${i + 1}`}
                  className="group relative glass h-full p-8 overflow-hidden transition-[transform,box-shadow] duration-500 hover:-translate-y-2 hover:shadow-[0_18px_55px_rgba(201,162,39,0.12)]"
                  style={{ borderRadius: "4px 24px 4px 24px" }}
                >
                  <span className="absolute top-5 right-6 font-display text-3xl text-transparent select-none" style={{ WebkitTextStroke: "1px rgba(184,190,199,0.25)" }} aria-hidden="true">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#C9A227]/30 bg-[#C9A227]/10 text-[#C9A227] group-hover:bg-[#C9A227] group-hover:text-[#07111F] transition-[background-color,color] duration-400">
                    <Icon size={22} />
                  </div>
                  <h3 className="mt-5 font-display text-lg text-[#F5F7FA]">{s.t}</h3>
                  <p className="mt-3 text-sm text-[#EDF1F6] leading-relaxed">{s.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
